import { useSelector } from 'react-redux';
import useAuth from '../auth/useAuth';
import usePermissions, { ManagerRole } from '../auth/usePermissions';
import { shouldShowIntercom } from '../../services/tenant/intercomVisibility';

const STORE_ROLES = [ManagerRole.StoreAdmin, ManagerRole.StoreEmployee, ManagerRole.StoreOperator];

/**
 * Whether this session gets the Intercom Messenger (shouldShowIntercom): the provider's `messenger_audience` decides
 * — everyone under FoodAmigos, only the admins of a white-label partner (for the FIN agent), nobody under a legacy
 * reseller. IntercomWidget boots on it and the platform agent's companion launcher shows on it, so the two agree.
 */
export default function useIntercomVisible() {
  const { company } = useSelector((state) => state.currentCompany);
  const { franchise } = useSelector((state) => state.currentFranchise);
  const { profile } = useSelector((state) => state.initialData);

  const { isLoggedIn } = useAuth();
  const { isSuperAdmin, hasGlobalAccess, hasAnyRole } = usePermissions();

  return shouldShowIntercom({
    appId: import.meta.env.VITE_INTERCOM_APP_ID,
    isLoggedIn,
    isSuperAdmin,
    hasGlobalAccess,
    isStoreUser: hasAnyRole(STORE_ROLES, false),
    isAdmin: hasAnyRole([ManagerRole.Admin], false),
    ownProvider: profile?.service_provider,
    company,
    franchise,
  });
}
